module.exports = __webpack_public_path__ + "static/media/nineteenth_robert_n_stewart_bridge4.9a433192.png";